import React, { useEffect, useState, useRef } from "react";
import NavBarTop from "../Reusable_Components/NavBarTop";
import LeftNavBar from "../Reusable_Components/LeftNavBar";
import { GoSearch } from "react-icons/go";
import Pagination from "../Reusable_Components/Pagination";
import { RECORDS_PER_PAGE_METER_MASTER } from "../../Config";
import TableComponent from "../Reusable_Components/TableComponent";
import Footer from "../Login/Footer";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import UploadComponent from '../Reusable_Components/UploadComponent';
import {
    eleminateSpacesAtStartOfInputField, processAndValidateEmail,
    checkUniqueness, toTitleCase, validateValue, formatNumericparseFloatInput, formatToWholeNumber,
    eleminateAllSpaces,
    convertUTCToLocal,
    validateGstNumber
} from "../Reusable_Components/ReusableFunctions";
import {
    facilityManagerGetAllAssets, handlePaginationLoaderTrue, getAssetStatusList,
    getAssetCategoryList, getAssetTypeList, creatingNewAsset, updatingExistingAsset, getAllCompaniesListDropdown, createNewAmc, getAmcCategory, getAmcRenewalPeriod,
    commercialHeadGetBillingEntities, getAmcForAsset, getSpicificAmcDetails, CONTRACT_API_LOADER_TRIGGER_TRUE, CREATE_NEW_AMC_FAILURE,
    CREATE_NEW_AMC_SUCCESS, getAllForms, CREATING_NEW_ASSET_SUCCESS, uploadDocumentForAsset, getAllDocumentsForAsset,
    facilityManagerGetAllAssetsDropdown, uploadDocumentForAmc, getAllDocumentsForAmc,
    getAllRecordsForAssetMaintenanceHistory, GET_ALL_AMC_FOR_ASSET_SUCCESS, addNewAssetCategory, getAssetCategories,
    commercialHeadGetAllFacilitiesForNav
} from '../../Redux/Actions/Actions'
import { useDispatch, useSelector } from "react-redux";
import { Button, Spinner } from "react-bootstrap";
import axios from "axios";
import { base_url } from "../../utilities";
import Modal from 'react-bootstrap/Modal';
import { set } from "date-fns";
import ViewForm from '../FormBuilder/ViewForm';
import Loader from '../Reusable_Components/loader';
import AlertPopUp from "../Reusable_Components/Alert";
import { error } from "pdf-lib";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useLocation } from "react-router-dom";
import { local, text } from "d3";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";



export default function OrganizationProfile() {

    const navigate = useNavigate()
    const location = useLocation()
    const { props } = location.state || {};
    const [orgID, setOrgId] = useState(localStorage.getItem("org_id"))
    // const [orgID, setOrgId] = useState("f6795ffa-1e66-4647-999b-327ecce7e17b")

    useEffect(() => {
        const details = {
            asset_id: props?.entity_id,
        }
        if (details?.asset_id) {
            handleViewActionClicked(details)
        }
    }, [props])

    const dispatch = useDispatch();
    const error = useSelector(state => state.error)

    const contractApiLoader = useSelector(state => state.contractApiLoader)
    const getAllAssetsListDropdown = useSelector(state => state.getAllAssetsListDropdown)
    const name = localStorage.getItem("name")
    const porfileUsername = localStorage.getItem("username")

    const [businessName, setBusinessName] = useState("");
    const [businessGstNumber, setBusinessGstNumber] = useState("");
    const [businessHcnNumber, setBusinessHcnNumber] = useState("");
    const [orgDescription, setOrgDescription] = useState("");
    const [orgTypeId, setOrgTypeId] = useState("");
    const [orgStatus, setOrgStatus] = useState("");
    const [orgStartDate, setOrgStartDate] = useState("");
    const [businessAddress, setBusinessAddress] = useState("");
    const [businessAddress2, setBusinessAddress2] = useState("");
    const [businessCity, setBusinessCity] = useState("");
    const [businessZipcode, setBusinessZipcode] = useState("");
    const [businessState, setBusinessState] = useState("");
    const [businessCountry, setBusinessCountry] = useState("");
    const [businessPhone, setBusinessPhone] = useState("");
    const [businessEmail, setBusinessEmail] = useState("");
    const [dateFormat, setDateFormat] = useState(localStorage.getItem("date_format"));
    const [currencyFormat, setCurrencyFormat] = useState(localStorage.getItem("currency_format"));
    const [timeZone, setTimeZone] = useState(localStorage.getItem("timezone"));
    const [numericFormat, setNumericFormat] = useState(localStorage.getItem("numeric_format"));
    const [orgNameList, setOrgNameList] = useState([]);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [userName, setUserName] = useState("");
    const [isEmailValid, setIsEmailValid] = useState(true);

    const [isOrgNameValid, setIsOrgNameValid] = useState(true);
    const [isOrgNameUnique, setIsOrgNameUnique] = useState(true);
    const [orgnameDummy, setOrgnameDummy] = useState("");
    const [isphoneNumberValid, setIsPhoneNumberValid] = useState(true);

    const [lovDateFormats, setLovDateFormats] = useState([]);
    const [lovCurrencyFormats, setLovCurrencyFormats] = useState([]);
    const [lovTimeZones, setLovTimeZones] = useState([]);
    const [lovNumericFormats, setLovNumericFormats] = useState([]);


    const getOrganisationDetails = (orgID) => {
        setLoader(true)
        axios.get(`${base_url}subscription/organization`, {
            params: {
                filter_condition: JSON.stringify({
                    org_id: orgID
                })
            }
        })
            .then((response) => {
                const responseData = response.data?.data;
                const orgDetails = responseData?.[0];
                setBusinessName(orgDetails?.business_name)
                setGstNumber(orgDetails?.business_gst_number)
                setBusinessHcnNumber(orgDetails?.business_hcn_number)
                setOrgDescription(orgDetails?.org_description)
                setOrgTypeId(orgDetails?.org_type_id)
                setOrgStatus(orgDetails?.org_status)
                setOrgStartDate(orgDetails?.org_start_date)
                setBusinessAddress(orgDetails?.business_address)
                setBusinessAddress2(orgDetails?.business_address2)
                setBusinessCity(orgDetails?.business_city)
                setBusinessZipcode(orgDetails?.business_zipcode)
                setBusinessState(orgDetails?.business_state)
                setBusinessCountry(orgDetails?.business_country)
                setBusinessPhone(orgDetails?.business_phone)
                setBusinessEmail(orgDetails?.business_email)
                setDateFormat(orgDetails?.date_format)
                setCurrencyFormat(orgDetails?.currency_format)
                setTimeZone(orgDetails?.time_zone)
                setNumericFormat(orgDetails?.numeric_format)
                setFirstName(orgDetails?.first_name)
                setLastName(orgDetails?.last_name)
                setUserName(orgDetails?.user_name)
                setOrgId(orgDetails?.org_id)
                setLoader(false)
                setOrgnameDummy(orgDetails?.business_name)

            })
            .catch((error) => {
                setLoader(false)
            })
    }

    const [isAssetNameValid, setIsAssetNameValid] = useState(true);
    const [isAssetNameUnique, setIsAssetNameUnique] = useState(true);

    const getAllOrganisationDetails = () => {
        axios.get(`${base_url}subscription/organization`)
            .then((response) => {
                const data = response.data?.data;
                const orgNameList = data?.map((item) => (
                    item.business_name
                ))
                setOrgNameList(orgNameList)
            })
            .catch((error) => {
                console.log("error", error)
            })
    }

    const postOrganisationDeatils = () => {
        setLoader(true)
        if (orgID) {
             let orgStatus = "gst_pending"
            if (gstNumber && businessName && businessAddress && businessZipcode) {
                orgStatus = "gst_verified"
            }

            const body = {
                org_id: orgID,
                business_name: businessName,
                business_gst_number: gstNumber,
                business_hcn_number: businessHcnNumber,
                org_description: orgDescription,
                org_type_id: orgTypeId,
                org_status: orgStatus,
                org_start_date: orgStartDate,
                business_address: businessAddress,
                business_address2: businessAddress2,
                business_city: businessCity,
                business_zipcode: businessZipcode,
                business_state: businessState,
                business_country: businessCountry,
                business_phone: businessPhone,
                business_email: businessEmail,
                date_format: dateFormat,
                currency_format: currencyFormat,
                time_zone: timeZone,
                numeric_format: numericFormat
            }
            axios.put(`${base_url}subscription/organization`, body)
                .then((response) => {
                    setLoader(false)
                    setAlertShow(true)
                    setAlertType('success')
                    setAlertMessage('Success')
                    setAlertValue('Organization Profile Updated Successfully')
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                                setAlertValue('')
                                navigate("/users")
                            }
                        },
                    ])
                    localStorage.setItem("org_id", orgID)
                    localStorage.setItem("date_format", dateFormat)
                    localStorage.setItem("currency_format", currencyFormat)
                    localStorage.setItem("timezone", timeZone)
                    localStorage.setItem("numeric_format", numericFormat)
                    if (orgStatus === "gst_verified") {
                        localStorage.setItem("gst_verification", orgStatus)
                    }
                })
                .catch((error) => {
                    setLoader(false)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(error?.response?.data?.message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                                setAlertValue('')
                            }
                        },
                    ])
                })

        } else {
            // {
            //     "business_name": "sathivk Inc.",
            //     "business_gst_number": "GST123456789",
            //     "business_hcn_number": "HCN987654321",
            //     "org_description": "A leading tech company specializing in AI solutions.",
            //     "org_type_id": "1",
            //     "org_status": "Active",
            //     "org_start_date": "2025-01-01",
            //     "business_address": "123 Tech Park",
            //     "business_address2": "Suite 456",
            //     "business_city": "San Francisco",
            //     "business_zipcode": "94107",
            //     "business_state": "California",
            //     "business_country": "USA",
            //     "business_phone": "+1-800-555-1234",
            //     "business_email": "contact@techsolutions.com",
            //     "date_format": "MM/DD/YYYY",
            //     "currency_format": "USD",
            //     "time_zone": "PST",
            //     "numeric_format": "1,000.00"
            // }

            const orgDate = new Date().toISOString().split('T')[0];

            const body = {
                business_name: businessName,
                business_gst_number: gstNumber,
                business_hcn_number: businessHcnNumber,
                org_description: orgDescription,
                org_type_id: orgTypeId,
                org_status: "ACTIVE",
                org_start_date: orgDate,
                business_address: businessAddress,
                business_address2: businessAddress2,
                business_city: businessCity,
                business_zipcode: businessZipcode,
                business_state: businessState,
                business_country: businessCountry,
                business_phone: businessPhone,
                business_email: businessEmail,
                date_format: dateFormat,
                currency_format: currencyFormat,
                time_zone: timeZone,
                numeric_format: numericFormat
            }

            axios.post(`${base_url}subscription/organization`, body)
                .then((response) => {
                    const data = response.data?.data;
                    const orgId = data?.org_id;
                    setOrgId(orgId)
                    localStorage.setItem("org_id", orgId)
                    setLoader(false)
                    setAlertShow(true)
                    setAlertType('success')
                    setAlertMessage('Success')
                    setAlertValue('Organization Profile Created Successfully')
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                                setAlertValue('')
                            }
                        },
                    ])

                })
                .catch((error) => {
                    setLoader(false)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(error?.response?.data?.message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                                setAlertValue('')
                            }
                        },
                    ])
                })
        }
    }

    const getLovDateFormats = () => {
        axios.get(`${base_url}listOfValues`, {
            params: {
                filter_condition: JSON.stringify({
                    lov_code: "DATE_FORMAT"
                })
            }
        })
            .then((response) => {
                const data = response.data?.data;
                setLovDateFormats([...data])
            })
            .catch((error) => {
                console.log("error", error)
            })
    }

    const getLovCurrencyFormats = () => {
        axios.get(`${base_url}listOfValues`, {
            params: {
                filter_condition: JSON.stringify({
                    lov_code: "CURRENCY"
                })
            }
        })
            .then((response) => {
                const data = response.data?.data;
                setLovCurrencyFormats([...data])
            })
            .catch((error) => {
                console.log("error", error)
            })
    }

    const getLOVNumericFormat = () => {
        axios.get(`${base_url}listOfValues`, {
            params: {
                filter_condition: JSON.stringify({
                    lov_code: "NUMERIC_FORMAT"
                })
            }
        })
            .then((response) => {
                const data = response.data?.data;
                setLovNumericFormats([...data])
            })
            .catch((error) => {
                console.log("error", error)
            })
    }

    const getLovTimeZones = () => {
        axios.get(`${base_url}listOfValues`, {
            params: {
                filter_condition: JSON.stringify({
                    lov_code: "TIME_ZONE"
                })
            }
        })
            .then((response) => {
                const data = response.data?.data;
                setLovTimeZones([...data])
            })
            .catch((error) => {
                console.log("error", error)
            })
    }

    useEffect(() => {
        dispatch(commercialHeadGetAllFacilitiesForNav())
        getAllOrganisationDetails()
        getLovDateFormats()
        getLovCurrencyFormats()
        getLovTimeZones()
        getLOVNumericFormat()
    }, [dispatch])

    useEffect(() => {
        if (orgID) {
            getOrganisationDetails(orgID)
        }
    }, [orgID])

    useEffect(() => {
        if (error) {
            setAlertShow(true)
            setAlertType('error')
            setAlertMessage('Error')
            setAlertValue(error?.response?.data?.message)
            setAlertButtons([
                {
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        // backfunction()
                        // amcBackFunction()

                    }
                },
            ])
        }
    }, [error])

    useEffect(() => {
        if (porfileUsername && name) {
            const name1 = name?.split(" ")
            setFirstName(name1[0])
            setLastName(name1[1])
            setUserName(porfileUsername)
        }
    }, [name, porfileUsername])

    const [alertShow, setAlertShow] = useState(false)
    const [alertType, setAlertType] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertValue, setAlertValue] = useState('')
    const [alertButtons, setAlertButtons] = useState([])
    const [activeTab, setActiveTab] = useState('1');

    const handleBack = () => {
        switch (activeTab) {
            case '3':
                setActiveTab('2');
                break;
            case '2':
                setActiveTab('1');
                break;
            default:
                backfunction();
        }
    };


    const [viewClicked, setViewClicked] = useState(false);



    const [isSpaceNameValid, setIsSpaceNameValid] = useState(true);


    const [isAssetNumberValid, setIsAssetNumberValid] = useState(true);
    const [isAssetNumberUnique, setIsAssetNumberUnique] = useState(true);

    const handleViewActionClicked = (data) => {

    };

    const backfunction = () => {
    }


    const handleNextClickedViewMode = () => {
        switch (activeTab) {
            case '1':
                setActiveTab('2');
                break;
            case '2':
                setActiveTab('3');
                break;
            case '3':
                setActiveTab('4');
                break;
            default:
                backfunction();
        }

    }
    const [loader, setLoader] = useState(false)
    const [gstLoader, setGstLoader] = useState(false)
    const [errorValue, setErrorValue] = useState(false)
    const [gstNumber, setGstNumber] = useState("");
    const [isValidGstNumber, setIsValidGstNumber] = useState(true);

    const handleGstNumberChange = (e) => {
        const input = e.target.value;
        const { isValid, uppercasedInput } = validateGstNumber(input);
        setGstNumber(uppercasedInput);
        setIsValidGstNumber(isValid);
    };

    const handleKeyPressForGst = (e) => {
        const allowedKeys = [
            'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
            'Backspace', 'Delete', 'Tab', 'Enter',
            'Home', 'End', 'PageUp', 'PageDown', 'Escape'
        ];
        if (allowedKeys.includes(e.key)) {
            return;
        }
        const allowedChars = /^[0-9a-zA-Z]$/;
        if (!allowedChars.test(e.key)) {
            e.preventDefault();
        }
    };
    const GstLoader = () => {
        return <Spinner style={{ height: "18px", width: "18px" }} animation="border" variant="light" />
    }

    const handleGstClick = (gstId) => {
        setGstLoader(true)
        axios.get(base_url + "gstPortal/verifyGstin?gst_number=" + gstId)
            .then((response) => {
                if (response?.data?.data[0] === 'error') {
                    setErrorValue(response?.data?.data[1].message)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(response?.data?.data[1].message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                            }
                        },
                    ])
                    // setIsLoading(false)
                    setGstLoader(false);
                }
                else {
                    const details = response.data.data
                    // setCompanyName(details?.company_name)
                    // setPanName(details?.pan_number)
                    // setRegisteredStateProvince(details?.registered_address?.state)
                    // setRegisteredPostalCode(details?.registered_address?.postal_code)
                    // setRegisteredStreetAddress(details?.registered_address?.door_number + details?.registered_address?.street_address_1)
                    // setRegisteredStreetAddressLane2(details?.registered_address?.street_address_2)
                    // setRegisteredCity(details?.registered_address?.city)
                    // setRegisteredCountry(details?.registered_address?.country)

                    // setBillingStateProvince(details?.registered_address?.state);
                    // setBillingCountry(details?.registered_address?.country);
                    // // setBillingPostalCode(details?.registered_address?.postal_code);
                    // setShippingStateProvince(details?.registered_address?.state);
                    // setShippingCountry(details?.registered_address?.country);
                    // // setShippingPostalCode(details?.registered_address?.postal_code);
                    setBusinessName(details?.company_name)
                    // setBusinessHcnNumber()
                    setBusinessAddress(details?.registered_address?.door_number + details?.registered_address?.street_address_1)
                    setBusinessAddress2(details?.registered_address?.street_address_2)
                    setBusinessCity(details?.registered_address?.city)
                    setBusinessState(details?.registered_address?.state)
                    setBusinessCountry(details?.registered_address?.country)
                    setBusinessZipcode(details?.registered_address?.postal_code)
                    setGstLoader(false)
                }
            })
            .catch((error) => {
                const errorDetails = JSON.parse(error.response.data.error_logs.status_desc);
                const errorMessage = errorDetails[0].ErrorMessage
                setErrorValue(errorMessage);
                setAlertShow(true);
                setAlertType('error');
                setAlertMessage('Error');
                setAlertValue(errorMessage);
                setAlertButtons([
                    {
                        name: 'Close',
                        action: () => {
                            setAlertShow(false);
                        }
                    }
                ]);
                // setIsLoading(false);
                setGstLoader(false);
            });
    }


    return (
        <>
            <>
                <NavBarTop />
                <LeftNavBar />
                {
                    contractApiLoader ?
                        <Loader />
                        :
                        null
                }
                {loader && <Loader />}
                <AlertPopUp alertShow={alertShow} alertType={alertType}
                    alertMsg={alertMessage} alertValue={alertValue} alertButtons={alertButtons} />
            </>

            <div className="newAssetContainer">
                <div style={{ display: "flex", flexDirection: "column", margin: '10px', width: "100vw", marginBottom: "100px" }}>
                    <div>
                        <h2>Organization Profile</h2>
                    </div>
                    <div style={{ marginTop: "20px" }}>
                        <Tabs
                            activeKey={activeTab}
                            onSelect={(k) => setActiveTab(k)}
                            id="uncontrolled-tab-example"
                            className="mb-0"
                        >
                            <Tab eventKey="1" title="Basic Information"
                                className="assetTabs" >
                                <div className="infoBody" style={{ height: '57vh' }}>
                                    <div>
                                        <h7 style={{ fontWeight: "bold" }}>Organization Details</h7>
                                        <div className="infoBodyInputs">
                                            <div className="responsiveInputSection">
                                                <div style={{ display: "flex", flexDirection: "row" }}>
                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <label className='add-facility-modal-label'>GST Number {<span style={{ color: "red" }}>*</span>}</label>
                                                        <input
                                                            //  disabled={viewClicked || editCompleteContractClicked}
                                                            type='text' value={gstNumber} onChange={handleGstNumberChange} onKeyDown={handleKeyPressForGst} className='form-control ' style={{ width: "90%", border: "0.5px solid #9D9D9C", }} />
                                                        {!isValidGstNumber && <span className="input-error-text">Invalid GST number</span>}
                                                    </div>
                                                    {/* >>> */}
                                                    {
                                                        !viewClicked ? (
                                                            <div style={{ marginBottom: "0px", display: "flex", alignItems: "center", marginTop: "20px" }}>
                                                                <div
                                                                    style={{
                                                                        background: "grey",
                                                                        padding: "9px 10px",
                                                                        marginLeft: "-10px",
                                                                        borderRadius: "5px",

                                                                        opacity: gstNumber === '' || !isValidGstNumber ? 0.3 : 1,
                                                                        pointerEvents: gstNumber === '' || !isValidGstNumber ? 'none' : 'auto'
                                                                    }}
                                                                    className="C-pointer"
                                                                    onClick={() => {
                                                                        if (gstNumber !== '' && isValidGstNumber) {
                                                                            setGstLoader(true);
                                                                            // dispatch(GstNumberDetails(gstNumber))
                                                                            handleGstClick(gstNumber);
                                                                        }
                                                                    }}
                                                                >
                                                                    {
                                                                        gstLoader && !errorValue ? (
                                                                            <GstLoader />
                                                                        ) : (
                                                                            <FaSearch color="white" size={20} style={{ fontWeight: "bolder" }} />
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        ) : null
                                                    }
                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Company Name {<span style={{ color: "red" }}>*</span>}</label>
                                                    <input type='text'
                                                        value={businessName}
                                                        disabled={true}

                                                        onChange={(e) => {
                                                            setBusinessName(e.target.value)
                                                            const isValid = /^[a-zA-Z0-9\s]{3,200}$/.test(e.target.value);
                                                            const isUnique = checkUniqueness(orgNameList, orgnameDummy, e.target.value);
                                                            setIsOrgNameValid(isValid);
                                                            setIsOrgNameUnique(!isUnique);
                                                        }}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                    {isOrgNameValid ? null : <span className='input-error-text'>Must be min of 3 to max of 200 characters</span>}
                                                    {isOrgNameUnique ? null : <span className='input-error-text'>Asset Name already exists</span>}
                                                </div>

                                                <div>
                                                    <label className='add-facility-modal-label'>CIN Number </label>
                                                    <input type='text'
                                                        value={businessHcnNumber}
                                                        disabled={viewClicked}

                                                        onChange={(e => setBusinessHcnNumber(e.target.value))}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                    {/* <select disabled={viewClicked} className='form-select responsive-add-facility-input-fields' value={billingEntity} onChange={handleBillingEntityChange}>
                                                        <option hidden>Select</option>
                                                        {
                                                            billingEntities?.map((entity, index) => (
                                                                <option key={entity.id} value={entity.partner_company_id}>{toTitleCase(entity.company_name)}</option>
                                                            ))
                                                        }

                                                    </select> */}
                                                </div>


                                            </div>

                                        </div>
                                    </div>
                                    <hr></hr>

                                    <div>
                                        <h7 style={{ fontWeight: "bold" }}>Registered Address</h7>
                                        <div className="infoBodyInputs">
                                            <div className="responsiveInputSection">
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Street Address  </label>
                                                    <input type='text'
                                                        value={businessAddress}
                                                        disabled={true}

                                                        onChange={(e => setBusinessAddress(e.target.value))}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Street Address Lane 2 </label>
                                                    <input type='text'
                                                        value={businessAddress2}
                                                        disabled={true}

                                                        onChange={e => setBusinessAddress2(e.target.value)}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                    {!isSpaceNameValid &&
                                                        <span className='input-error-text'>Must be min of 3 to max of 200 characters</span>}
                                                </div>
                                                <div>
                                                    <label className='add-facility-modal-label'>City </label>
                                                    <input type='text'
                                                        value={businessCity}
                                                        disabled={true}

                                                        onChange={e => setBusinessCity(e.target.value)}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                    {/* <select disabled={viewClicked} className='form-select responsive-add-facility-input-fields' value={billingEntity} onChange={handleBillingEntityChange}>
                                                        <option hidden>Select</option>
                                                        {
                                                            billingEntities?.map((entity, index) => (
                                                                <option key={entity.id} value={entity.partner_company_id}>{toTitleCase(entity.company_name)}</option>
                                                            ))
                                                        }

                                                    </select> */}
                                                </div>


                                            </div>
                                            <div className="responsiveInputSection">
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >State/Province </label>
                                                    <input type='text'
                                                        value={businessState}
                                                        disabled={true}

                                                        onChange={e => setBusinessState(e.target.value)}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Country </label>
                                                    <input type='text'
                                                        value={businessCountry}
                                                        disabled={true}

                                                        onChange={e => setBusinessCountry(e.target.value)}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                    {!isSpaceNameValid &&
                                                        <span className='input-error-text'>Must be min of 3 to max of 200 characters</span>}
                                                </div>
                                                <div>
                                                    <label className='add-facility-modal-label'>PIN Code </label>
                                                    <input type='text'
                                                        value={businessZipcode}
                                                        disabled={true}

                                                        onChange={e => setBusinessZipcode(e.target.value)}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                    {/* <select disabled={viewClicked} className='form-select responsive-add-facility-input-fields' value={billingEntity} onChange={handleBillingEntityChange}>
                                                        <option hidden>Select</option>
                                                        {
                                                            billingEntities?.map((entity, index) => (
                                                                <option key={entity.id} value={entity.partner_company_id}>{toTitleCase(entity.company_name)}</option>
                                                            ))
                                                        }

                                                    </select> */}
                                                </div>


                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </Tab>
                            <Tab eventKey="2" title="Contact Information"
                                className="assetTabs">
                                <div className="infoBody" style={{ height: '57vh' }}>
                                    <div>

                                        <div className="infoBodyInputs">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h7 style={{ fontWeight: "bold" }}>Contact Information</h7>
                                                {/* <h7 className='mt-2' style={{ textDecoration: "underline", cursor: "pointer", }}
                                                >Add Another Contact</h7> */}
                                            </div>
                                            {/* <label className='mt-2'
                                            >Contact 1</label> */}

                                            <div className="responsiveInputSection">
                                                <div >
                                                    <label className='add-facility-modal-label'>First Name </label>
                                                    <input type='text'
                                                        value={firstName}
                                                        disabled={true}
                                                        onChange={(e => setFirstName(e.target.value))}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                    {isAssetNameValid ? null : <span className='input-error-text'>Must be min of 3 to max of 200 characters</span>}
                                                    {isAssetNameUnique ? null : <span className='input-error-text'>Asset Name already exists</span>}
                                                </div>
                                                <div>
                                                    <label className='add-facility-modal-label'>Last Name</label>
                                                    <input
                                                        type='text'
                                                        value={lastName}
                                                        disabled={true}
                                                        onChange={(e => setLastName(e.target.value))}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                    {isAssetNumberValid ? null : <span className='input-error-text'>Must be min of 3 to max of 200 characters</span>}
                                                    {isAssetNumberUnique ? null : <span className='input-error-text'>Asset Number already exists</span>}
                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Phone Number </label>
                                                    {/* <input
                                                        type='text'
                                                        value={businessPhone}
                                                        disabled={viewClicked}
                                                        onChange={e => {
                                                            const input = e.target.value
                                                            // accept only numbers
                                                            const formattedInput = formatNumericparseFloatInput(input);
                                                            const isValidPhone = /^[0-9]{10}$/.test(formattedInput);
                                                            setBusinessPhone(formattedInput);
                                                            setIsPhoneNumberValid(isValidPhone);

                                                        }}
                                                        className='form-control responsive-add-facility-input-fields' /> */}
                                                        <PhoneInput
                                                            country={'in'}
                                                            value={businessPhone}
                                                            inputStyle={{ width: '100%' }}
                                                            disabled={viewClicked}
                                                            onChange={(value,country)=>{
                                                                setBusinessPhone("+"+value);
                                                            }}
                                                            
                                                        />
                                                    {!isphoneNumberValid &&
                                                        <span className='input-error-text'>Must be 10 digits</span>}
                                                </div>


                                            </div>
                                            <div className="responsiveInputSection" style={{ justifyContent: "space-between" }}>



                                                <div>

                                                    <label className='add-facility-modal-label'
                                                    // disabled={viewClicked}
                                                    >Email </label>
                                                    <input
                                                        type='text'
                                                        value={businessEmail}
                                                        disabled={viewClicked}
                                                        onChange={(e => {
                                                            const input = e.target.value;
                                                            const { processedInput, isValid } = processAndValidateEmail(input);
                                                            setBusinessEmail(input);
                                                            setIsEmailValid(isValid);

                                                        })}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                    {!isEmailValid &&
                                                        <span className='input-error-text'>Please enter a valid email address</span>}

                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="3" title="Configuration Settings"
                                className="assetTabs" >
                                <div className="infoBody" style={{ height: '57vh' }}>

                                    <div>
                                        <h7 style={{ fontWeight: "bold" }}>Configuration Settings</h7>
                                        <div className="infoBodyInputs">
                                            <div className="responsiveInputSection">
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Date Format </label>
                                                    {/* <input type='text'
                                                        value={dateFormat}
                                                        disabled={viewClicked}

                                                        onChange={e => setDateFormat(e.target.value)}
                                                        className='form-control responsive-add-facility-input-fields' /> */}
                                                    <select
                                                        value={dateFormat}
                                                        onChange={(event) => {
                                                            setDateFormat(event.target.value)
                                                        }}
                                                        className='form-select responsive-add-facility-input-fields'>
                                                        <option hidden>Select</option>
                                                        {lovDateFormats?.map((item) => (
                                                            <option key={item.lov_id} value={item.lov_value}>
                                                                {item.lov_value}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Time Zone </label>
                                                    {/* <input type='text'
                                                        value={timeZone}
                                                        disabled={viewClicked}

                                                        onChange={e => setTimeZone(e.target.value)}
                                                        className='form-control responsive-add-facility-input-fields' /> */}
                                                    <select
                                                        value={timeZone}
                                                        onChange={(event) => {
                                                            setTimeZone(event.target.value)
                                                        }}
                                                        className='form-select responsive-add-facility-input-fields'>
                                                        <option hidden>Select</option>
                                                        {lovTimeZones?.map((item) => (
                                                            <option key={item.lov_id} value={item.lov_value}>
                                                                {item.lov_value}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Currency </label>
                                                    {/* <input type='text'
                                                        value={currencyFormat}
                                                        disabled={viewClicked}

                                                        onChange={e => setCurrencyFormat(e.target.value)}
                                                        className='form-control responsive-add-facility-input-fields' /> */}
                                                    <select
                                                        value={currencyFormat}
                                                        onChange={(event) => {
                                                            setCurrencyFormat(event.target.value)
                                                        }}
                                                        className='form-select responsive-add-facility-input-fields'>
                                                        <option hidden>Select</option>
                                                        {lovCurrencyFormats?.map((item) => (
                                                            <option key={item.lov_id} value={item.lov_value}>
                                                                {item.lov_value}
                                                            </option>
                                                        ))}
                                                    </select>

                                                </div>



                                            </div>

                                        </div>
                                        <div className="infoBodyInputs">
                                            <div className="responsiveInputSection">
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Numeric Format</label>
                                                    <select
                                                        value={numericFormat}
                                                        onChange={(event) => {
                                                            setNumericFormat(event.target.value)
                                                        }}
                                                        className='form-select responsive-add-facility-input-fields'>
                                                        <option hidden>Select</option>
                                                        {lovNumericFormats?.map((item) => (
                                                            <option key={item.lov_id} value={item.lov_value}>
                                                                {item.lov_value}
                                                            </option>
                                                        ))}
                                                    </select>

                                                </div>



                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                    <div style={{ marginTop: "20px", }}>
                        {
                            activeTab === '1' && (
                                <div style={{ display: "flex", justifyContent: "end", }}>
                                    <button className="invoice_btn" style={{ color: "white" }} onClick={() => navigate(-1)}>Close</button>
                                    <button className="invoice_btn" style={{ marginLeft: "30px", color: "white" }} onClick={() => {
                                        setActiveTab('2')
                                    }}>Next</button>
                                </div>
                            )
                        }
                        {
                            activeTab === '2' && (
                                <div style={{ display: "flex", justifyContent: "end", }}>
                                    <button className="invoice_btn" style={{ color: "white" }} onClick={() => navigate(-1)}>Close</button>

                                    <button className="invoice_btn" style={{ color: "white" , marginLeft: "30px"}} onClick={handleBack}>Back</button>

                                    <button className="invoice_btn" style={{ marginLeft: "30px", color: "white" }} onClick={() => {
                                        setActiveTab('3')
                                    }}>Next</button>

                                </div>
                            )
                        }
                        {
                            activeTab === '3' && (
                                <div style={{ display: "flex", justifyContent: "end", }}>
                                    <button className="invoice_btn" style={{ color: "white" }} onClick={() => navigate(-1)}>Close</button>

                                    <button className="invoice_btn" style={{ color: "white", marginLeft: "30px" }} onClick={handleBack}>Back</button>
                                    <button className="invoice_btn" style={{ marginLeft: "30px", color: "white" }} onClick={() => { postOrganisationDeatils() }}>Save</button>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
